import React, { Fragment, useEffect, useState } from 'react'
import config from '../../../config'
import { Col, Row } from 'react-bootstrap'
import { Input, Tooltip } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'
import ChatbotDemo from '../../chatbot-demo'
import StepWizard from 'react-step-wizard'
import _ from 'lodash'
import './bot-preview.css'

const iconButton = (text) => {
  return (
    <Tooltip
      placement="right"
      title={<span style={{ whiteSpace: 'pre-line' }}>{text}</span>}
    >
      <InfoCircleOutlined
        style={{ color: '#38b549', marginLeft: 8, cursor: 'pointer' }}
      />
    </Tooltip>
  )
}

export default function(props) {
  const [selectedBot, setSelectedBot] = useState({})

  const [wizardState, updateWizardState] = useState({
    form: {},
  })

  const setInstance = (SW) =>
    updateWizardState({
      ...wizardState,
      SW,
    })

  const drawSelectedInfo = (wizardState, selectedBot) => {
    let { title, description, image } = selectedBot.template_info
    const { SW } = wizardState
    image = `${config.api.host}/api/v1/files/bot/template/image/${image}`

    return (
      <Fragment>
        <div className="selected-template-info">
          <img src={image} className="selected-template-img" alt="" />
          <span className="selected-template-title">{title}</span>
          <span className="selected-template-desc">{description}</span>
          <span className="selected-template-wyg">You Get</span>
          <ul className="checkmark">
            <li>Candidate Contact Info</li>
            <li>Pre-screen Responses</li>
            <li>New Candidate Profile emailed to your hiring team</li>
          </ul>
          <span className="selected-template-back" onClick={SW.previousStep}>
            &larr; Choose Another
          </span>
        </div>
      </Fragment>
    )
  }

  const drawCard = (
    title,
    description,
    image,
    id,
    selectedTemplate,
    onTapCard,
    state,
    bot,
  ) => {
    const active = selectedTemplate === id

    const { SW } = state

    return (
      <Col xs={6}>
        <div
          onClick={() => {
            if (bot) {
              setSelectedBot(bot)
              props.autobotProps.handleOnSelectTemplate(bot.id)
            }
          }}
        >
          <div
            className={`template-card-2 ${
              active ? 'template-card-2-active' : 'template-card-2-inactive'
            }`}
          >
            <div className="template-card-2-img-container">
              <img src={image} className="template-card-2-img" alt="" />
            </div>
            <div className="template-card-2-description-container">
              <span className="template-title">{title}</span>
              <span className="template-desc">{description}</span>
            </div>
          </div>
        </div>
      </Col>
    )
  }

  let templates = props.autobotProps.botTemplates.map((bot) => {
    return drawCard(
      bot.template_info.title,
      bot.template_info.description,
      `${config.api.host}/api/v1/files/bot/template/image/${bot.template_info.image}`,
      bot.id,
      selectedBot.id,
      () => {
        //do nothing
      },
      wizardState,
      bot,
    )
  })

  templates = _.chunk(templates,2)
  templates = templates.map(temp=> <Row>{temp}</Row>)

  const Nav = (props) => {
    const dots = []
    for (let i = 1; i <= props.totalSteps; i += 1) {
      let label = 'Step 1'

      switch (i) {
        case 1:
          label = 'Step 1'
          break
        case 2:
          label = 'Step 2'
          break
        case 3:
          label = 'Step 3'
          break
      }

      const isActive = props.currentStep === i
      dots.push(
        <span
          key={`step-${i}`}
          className={`${isActive ? 'store-step-active' : 'store-step'}`}
          onClick={() => props.goToStep(i)}
        >
          {label}
        </span>,
      )
    }

    return (
      <Row>
        <Col xs={12} className="navwizard-nav-container">
          {dots}
        </Col>
      </Row>
    )
  }

  const { SW } = wizardState

  return (
    <Fragment>
      <Row>
        <Col xs={12} md={12}>
          <Fragment>
            <Row>
              <Col xs={12} md={8} style={{ paddingLeft: '10px' }}>
                <StepWizard
                  // nav={<Nav />}
                  className="stepwizard-nav"
                  instance={setInstance}
                >
                  {/** step 1 */}
                  <Fragment>
                    <Row>
                      <Col xs={12}>
                        <h3 style={{ color: '#39B54A', fontWeight:'600' }}>Step 1: Branding</h3>
                      </Col>
                    </Row>
                    <Row>
                      {/**chose a script */}
                      <Col xs={12} md={12}>
                        <Row>
                          <Col
                            xs={4}
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              justifyContent: 'end',
                              alignItems: 'center',
                            }}
                          >
                            <span>Enter your Brand Name</span>
                            {iconButton(
                              `What's your Company's Brand name you want to\n show when we respond to the candidate?`,
                            )}
                          </Col>
                          <Col xs={8}>
                            <Input
                              status={props.autobotProps.brandNameError ? 'error' : undefined}
                              value={props.autobotProps.brandName}
                              onChange={
                                async(e)=>{
                                  await props.autobotProps.handleOnChange(
                                    'brandName',
                                  )(null, e.target.value)
                                  if (!selectedBot.id) {
                                    setSelectedBot(
                                      _.find(props.autobotProps.botTemplates,(t)=>t.template_info.title=='Basic Template') || _.first(props.autobotProps.botTemplates,),
                                    )
                                  }
                                  props.autobotProps.handleOnSelectTemplate(
                                    (selectedBot.id
                                      ? selectedBot
                                      : _.first(props.autobotProps.botTemplates)
                                    ).id,
                                  )
                                }
                            }
                            />
                          </Col>
                        </Row>

                        <Row style={{ marginTop: '10px' }}>
                          <Col
                            xs={4}
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              justifyContent: 'end',
                              alignItems: 'center',
                            }}
                          >
                            <span>Career site URL</span>
                            {iconButton(
                              `What's your company Career site URL,\nor where do you want us to direct candidates?`,
                            )}
                          </Col>
                          <Col xs={8}>
                            <Input
                              value={props.autobotProps.careerSiteUrl}
                              status={props.autobotProps.careerSiteError ? 'error' : undefined}
                              onChange={
                              async(e)=>{
                                  await props.autobotProps.handleOnChange(
                                    'careerSiteUrl'
                                  )(null, e.target.value)
                                  if (!selectedBot.id) {
                                    setSelectedBot(
                                      _.find(props.autobotProps.botTemplates,(t)=>t.template_info.title=='Basic Template') || _.first(props.autobotProps.botTemplates,),
                                    )
                                  }
                                  props.autobotProps.handleOnSelectTemplate(
                                    (selectedBot.id
                                      ? selectedBot
                                      : _.first(props.autobotProps.botTemplates)
                                    ).id,
                                  )
                                }
                              }
                            />
                          </Col>
                        </Row>
                        <Row style={{ marginTop: '20px' }}>
                          <Col xs={12}>
                            <h3 style={{ color: '#39B54A', fontWeight:'600' }}>
                              Step 2: Choose a Pre-built Apply-by-Text Template
                            </h3>
                          </Col>
                        </Row>
                        <Row style={{ marginTop: '20px' }}>
                          <Col xs={12}>
                            {templates}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Fragment>
                </StepWizard>
              </Col>

              {/**preview bot */}
              <Col xs={12} md={4}>
                <Row>
                  <Col
                    xs={12}
                    style={{
                      textAlign: 'center',
                      height: '675px',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'center',
                        alignContent: 'center',
                      }}
                    >
                      <ChatbotDemo script={props.autobotProps.script} />
                    </div>
                  </Col>
                </Row>

                <Row style={{ marginTop: '50px' }}>
                  <Col xs={12} style={{ textAlign: 'center' }}>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <button
                        style={{ margin: '0px 10px' }}
                        onClick={() => {
                          if (!selectedBot.id) {
                            setSelectedBot(
                              _.find(props.autobotProps.botTemplates,(t)=>t.template_info.title=='Basic Template') || _.first(props.autobotProps.botTemplates,),
                            )
                          }
                          props.autobotProps.handleOnSelectTemplate(
                            (selectedBot.id
                              ? selectedBot
                              : _.first(props.autobotProps.botTemplates)
                            ).id,
                          )

                          // SW.nextStep()
                        }}
                        className="store-btn store-btn-preview"
                      >
                        Preview &rarr;
                      </button>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Fragment>
        </Col>
      </Row>
    </Fragment>
  )
}
